import {createRouter, createWebHashHistory} from 'vue-router'

const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/index')
    },
    {
        path: '/',
        name: '首页',
        component: () => import('../layout'),
        children: [
            {
                path: '/system/user',
                name: '用户管理',
                component: () => import('../views/users.vue')
            },
            {
                path: '/system/menu',
                name: '菜单管理',
                component: () => import('../views/menu.vue')
            },
            {
                path: '/system/role',
                name: '角色管理',
                component: () => import('../views/role.vue')
            },
            {
                path: '/system/dept',
                name: '部门管理',
                component: () => import('../views/dept.vue')
            },
            {
                path: '/system/post',
                name: '岗位管理',
                component: () => import('../views/post.vue')
            },
            {
                path: '/individual',
                name: '个人中心',
                component: () => import('../views/individual.vue')
            },      {
                path: '/cardcoupon/cardcoupon',
                name: '新开卡券',
                component: () => import('../views/cardcoupon/cardcoupon.vue')
            },
            {
                path: '/cardcoupon/batch',
                name: '批次管理',
                component: () => import('../views/cardcoupon/batch.vue')
            },
            {
                path: '/cardcoupon/card',
                name: '卡券管理',
                component: () => import('../views/cardcoupon/card.vue')
            },
            {
                path: '/cardcoupon/cardinfo',
                name: '卡券订正',
                component: () => import('../views/cardcoupon/cardinfo.vue'),
            }, {
                path: '/cardcoupon/printbatch',
                name: '印刷批次管理',
                component: () => import('../views/cardcoupon/printbatch.vue')
            },
            {
                path: '/cardcoupon/cardCorrectLog',
                name: '卡券订正日志',
                component: () => import('../views/cardcoupon/cardCorrectLog.vue')
            },
            {
                path: '/cardcoupon/cardUsertLog',
                name: '卡券使用日志 ',
                component: () => import('../views/cardcoupon/cardUsertLog.vue')
            },
            {
                path: '/movie_order/movie_order',
                name: '订单信息',
                component: () => import('../views/movie_order.vue')
            },
            {
                path: '/monitor/member',
                name: '用户列表',
                component: () => import('../views/member.vue')
            },
            {
                path: '/monitor/batch',
                name: '卡券监控',
                component: () => import('../views/monitor_batch.vue')
            },
            {
                path: '/monitor/coupon',
                name: '卡券使用监控',
                component: () => import('../views/coupon.vue')
            },
            {
                path: '/log/systemlog',
                name: '系统日志',
                component: () => import('../views/log/systemlog.vue')
            },
            {
                path: '/monitor/risk-alarm',
                name: '风控告警',
                component: () => import('../views/monitor/risk-alarm.vue')
            },
            {
                path: '/monitor/white-list',
                name: '白名单列表',
                component: () => import('../views/monitor/white-list.vue')
            },
            {
                path: '/monitor/monitorCoupon',
                name: '次券监控',
                component: () => import('../views/monitor/monitorCoupon.vue')
            },
            {
                path: '/monitor/monitorCard',
                name: '储值卡监控',
                component: () => import('../views/monitor/monitorCard.vue')
            },

            {
                path: '/monitor/black-op-log',
                name: '黑名单操作记录',
                component: () => import('../views/monitor/black-op-log.vue')
            },
            {
                path: '/activity/activity-module',
                name: '轮播图活动模块管理',
                component: () => import('../views/activity/activity-module.vue')
            },
            //商城商品管理
            {
                path: '/mall-product-management/product-info',
                name: '商品信息管理',
                component: () => import('../views/mall-product-management/product-info.vue')
            },
            {
                path: '/mall-product-management/category-info',
                name: '商品分类管理',
                component: () => import('../views/mall-product-management/category-info.vue')
            },
            {
                path: '/order/order_list',
                name: '订单列表管理',
                component: () => import('../views/order/order_list.vue')
            },
            {
                path: '/order/order_refund',
                name: '售后订单列表',
                component: () => import('../views/order/order_refund.vue')
            },
            {
                path: '/customerservice/store_sales',
                name: '门店销售列表',
                component: () => import('../views/customerservice/store_sales.vue')
            },
            {
                path: '/data_statistics/batch_order',
                name: '月份销售数据',
                component: () => import('../views/data_statistics/batch_order.vue')
            },
            {
                path: '/data_statistics/data-static-table',
                name: '月份统计退货数据',
                component: () => import('../views/data_statistics/data-static-table.vue')
            },
            {
                path: '/data_statistics/store_data_static',
                name: '店铺卡券销售数据统计',
                component: () => import('../views/data_statistics/store_data_static.vue')
            },


        ]
    },

]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

//全局守卫：登录拦截 本地没有存token,请重新登录
router.beforeEach((to, from, next) => {
    // 判断有没有登录
    if (!localStorage.getItem('token')) {
        // const token = localStorage.getItem('token')
        // console.log(token)
        if (to.path === "/login") {
            next();
        } else {
            next('/login')
        }
    } else {
        next();
    }
});


export default router
